import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Servers from '../views/Servers.vue'
import RestartLogs from '../views/RestartLogs.vue'
import Notifications from '../views/Notifications.vue'
import NotificationLogs from '../views/NotificationLogs.vue'
import AutoRestart from '../views/AutoRestart.vue'
import NotificationConfig from '../views/NotificationConfig.vue'
import Login from '../views/Login.vue'
import { getAuthFromCookie } from '@/plugins/axios'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/servers',
    name: 'Servers',
    component: Servers,
    meta: { requiresAuth: true }
  },
  {
    path: '/restart-logs',
    name: 'RestartLogs',
    component: RestartLogs,
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { requiresAuth: true }
  },
  {
    path: '/notification-logs',
    name: 'NotificationLogs',
    component: NotificationLogs,
    meta: { requiresAuth: true }
  },
  {
    path: '/auto-restart',
    name: 'AutoRestart',
    component: AutoRestart,
    meta: { requiresAuth: true }
  },
  {
    path: '/notification-config',
    name: 'NotificationConfig',
    component: NotificationConfig,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Route guard - auth kontrolü
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!getAuthFromCookie()
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router